export default function DownloadIconV2({
    style,
}) {
    return <svg style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 13.4453H17C17 15.409 15.4081 17.0009 13.4444 17.0009H4.55556C2.59188 17.0009 1 15.409 1 13.4453Z" fill="#83CFA4" />
        <path d="M4.55566 7.21875L8.55566 10.7743L12.5557 7.21875" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.75 1C9.75 0.585786 9.41421 0.25 9 0.25C8.58579 0.25 8.25 0.585786 8.25 1H9.75ZM8.25 1V10.7778H9.75V1H8.25Z" fill="#536987" />
        <path d="M1 11.2257V14.0035C1 15.6603 2.34315 17.0035 4 17.0035H14C15.6569 17.0035 17 15.6603 17 14.0035V10.7812" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}